import { gql } from '@apollo/client';

export default gql`
  mutation setSelectedPort($port: String) {
    setSelectedPort(port: $port) @client
  }
`;
